import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../UserAccountLinker.module.scss";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { MdAccountCircle } from "react-icons/md";
import Axios from "../../../_services/caller.service";
import Loader from "../../UiComponents/loader/Loader";

const LoginInvite = ({
  setUserId,
  setUserName,
  senderOwner,
  userMailSignIn,
  userPasswordSignIn,
  setUserMailSignIn,
  setUserPasswordSignIn,
  confirmInvitation,
  setNameForEmailSuccess,
}) => {
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

  const submitForms = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    Axios.post(`/inviteUserLogin`, {
      userMailSignIn,
      userPasswordSignIn,
    })
      .then((res) => {
        // SECURITE F6 : le JWT d'invitation est desormais transporte par
        // le cookie httpOnly hs_invite pose par le serveur. Plus de stockage
        // en localStorage (exfiltrable par XSS).
        const userId = res.data.id;
        setUserName(res.data.name);
        confirmInvitation(userId);
      })
      .catch((error) => {
        const msg = error.response?.data?.msg || t("auth.connection_error");
        setErrorMsg(msg);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className={styles.formCard}>
      <p className={styles.formTitle}>
        {t("invite.login_auto_link", { owner: senderOwner })}
      </p>
      <form onSubmit={submitForms}>
        <div className={styles.formGroup}>
          <input
            className={styles.input}
            type="text"
            placeholder={t("common.username_email_placeholder")}
            value={userMailSignIn}
            onChange={(e) => {
              setUserMailSignIn(e.target.value);
              setNameForEmailSuccess(capitalize(e.target.value));
            }}
            required
          />

          <div className={styles.inputWrapper}>
            <input
              className={styles.inputPassword}
              type={showPassword ? "text" : "password"}
              placeholder={t("login.password_label")}
              value={userPasswordSignIn}
              onChange={(e) => setUserPasswordSignIn(e.target.value)}
              required
            />
            <button
              type="button"
              className={styles.passwordToggle}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
            </button>
          </div>

          {errorMsg && <div className={styles.validationError}>{errorMsg}</div>}

          <button type="submit" className={styles.btnSubmit} disabled={loading}>
            <MdAccountCircle /> {t("invite.login_button")}
          </button>

          {loading && <div className={styles.loader}><Loader /></div>}
        </div>
      </form>
    </div>
  );
};

export default LoginInvite;
